import React from 'react';
import styles from '../styles/components/_InfoBlock.module.scss';

const InfoBlock = ({
    dateParts,
    dateFinParts,
    typePerformance,
    title,
    subtitle,
    titleTag = 'h3',
    theme = 'light',
    supportProps = {},
    showSupports = true,
    showVerticalLabel = true,
    additionalArtists = [],
    addInfosEvent,
    variant = 'card'
}) => {
    const TitleTag = titleTag;
    
    // Normalisation des supports et filtrage des supports vides
    const supports = Array.isArray(subtitle)
        ? subtitle.filter(s => s && s.trim() !== '')
        : (typeof subtitle === 'string' 
            ? subtitle.split(',').map(s => s.trim()).filter(s => s !== '')
            : []);
    
    // Props par défaut pour les supports
    const defaultSupportProps = {
        labelSingular: 'SUPPORT',
        labelPlural: 'SUPPORTS',
        className: styles.support
    };
    
    // Fusion des props des supports
    const mergedSupportProps = { ...defaultSupportProps, ...supportProps };

    // Vérifier si la date de fin est différente de la date de début
    const hasDifferentEndDate = dateFinParts && 
                              dateFinParts.day && 
                              dateFinParts.day !== dateParts?.day;

    // Vérifier si le typePerformance contient du texte
    const hasTypePerformance = typePerformance && typePerformance.trim() !== '' && typePerformance !== "Null";

    return (
        <div className={`${styles.infoBlock} ${styles[theme]} ${styles[variant]}`}>
            {dateParts && (
                <div className={styles.dateWrapper}>
                    <div className={styles.dayOfWeek}>
                        {hasDifferentEndDate ? (
                            <>
                                <span className={styles.day}>{dateParts.day}</span>
                                <span style={{ margin: '0 0.5rem' }}>&gt;</span>
                                <span className={styles.day}>{dateFinParts.day}</span>
                            </>
                        ) : (
                            <>
                                {dateParts.dayOfWeek}. <span className={styles.day}>{dateParts.day}</span>
                            </>
                        )}
                    </div>
                    <div className={styles.separator}></div>
                    <div className={styles.month}>{dateParts.month}</div>
                </div>
            )}
            
            {/* Wrapper pour titre et artistes add. - ASSURER la classe ici */}
            <div className={styles.titleSection}>
                {/* Bloc Titre */}
                {title && (
                    <div className={styles.mainTitle}>
                        {hasTypePerformance && showVerticalLabel && (
                            <div className={styles.verticalLabel}>
                                {typePerformance}
                            </div>
                        )}
                        <TitleTag 
                          className={styles.title}
                        >
                          <span>{title}</span>
                        </TitleTag>
                    </div>
                )}
                {/* Bloc Artistes Additionnels */}
                {additionalArtists.length > 0 && (
                    <div className={styles.additionalArtists}>
                        {additionalArtists.map((artist, index) => (
                            <React.Fragment key={index}>
                                {index > 0 && <span>-</span>}
                                <div>{artist}</div>
                            </React.Fragment>
                        ))}
                    </div>
                )}
            </div>
            {/* Fin du wrapper */}

            {/* Ajouter la barre AVANT les supports si les supports existent */} 
            {showSupports && supports.length > 0 && (
                 <div className={styles.separatorLineBeforeSupports}></div>
            )}

            {showSupports && supports.length > 0 && (
                <div className={styles.supportsWrapper}>
                    <div className={styles.supports}>
                        {supports.map((support, index) => (
                            <div
                                key={index}
                                className={mergedSupportProps.className}
                            >
                                {support}
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {addInfosEvent && (
                <>
                    <div className={styles.separatorLine}></div>
                    <div className={styles.additionalInfo}>
                        {addInfosEvent}
                    </div>
                </>
            )}
        </div>
    );
};

export default InfoBlock;